import { required } from 'utils/errorsTextHelper';
import * as yup from 'yup';

const quantityEntrySchema = yup.object().shape({
  quantity: yup.object().shape({
    milSeparator: yup.string().required(required('Million separator')),
    maxDigitsWithoutShorthand: yup
      .number()
      .min(3, 'Max digits without shorthand must be at least 3')
      .required('Max digits without shorthand is required')
  })
});

export const storeSettingsSchema = yup.object().shape({
  numberFormat: yup.object().shape({
    products: quantityEntrySchema,
    balance: quantityEntrySchema,
    specialOffer: quantityEntrySchema,
    rollingOffer: quantityEntrySchema
  })
});
